import { useState, useEffect} from "react"
import Label from "../../../../components/ui/labels/Label"
import { InputContainer } from "../../../../components/ui/inputs/InputContainers"
import { Input } from '../../../../components/ui/inputs/Input'

/**
 * Component for editing linked POI name and description on POIGroups tab
 * 
 * @param {Object} poi original POI from parent - to get linkedPOI for current group, and original POI name
 * @param {number} poiGroupID 
 * @param {Function} handleAltDataChange - update name and description change for linkedPOI in parent component
 * @param {Boolean} isDisabled 
 * 
 * @returns {JSX.Element}
 */
export const AltData = ({poi, poiGroupID, handleAltDataChange, isDisabled}) => {

    const [currentAltName, setCurrentAltName] = useState()
    const [currentAltDescription, setCurrentAltDescription] = useState()
    const [linkedPOI, setLinkedPOI] = useState()

    useEffect(() => {
        const linkedPOI =  poi.linkedPOIs?.find(linkedPOI => linkedPOI.POIGroupID === poiGroupID)
        
        setLinkedPOI(linkedPOI)
        setCurrentAltName(linkedPOI?.POI_Name ?? "");
        setCurrentAltDescription(linkedPOI?.Description ?? "");
    },[poi])

    return (

        <div className='mb-1 flex flex-col md:flex-row justify-between items-start md:items-center max-w-4xl'>
                  
            {/* poi original name */}
            <div className="w-32 mb-4 mr-4">
                <label className="font-semibold">
                    {poi.label}
                </label>
            </div>

            {/* alt name input */}
            <InputContainer>
            
                <Label
                    htmlFor={`group-${poiGroupID}poi-${poi.value}-name`}
                >
                    Alt name
                </Label>
                
                <Input
                    id={`group-${poiGroupID}poi-${poi.value}-name`}
                    type="text"
                    value={currentAltName}
                    onChange={(e) => setCurrentAltName(e.target.value)}
                    onBlur={() => handleAltDataChange({ POI_Name: currentAltName }, poi.value, linkedPOI)}
                    disabled={isDisabled}
                />
            </InputContainer>

            {/* alt description input */}
            <InputContainer>
            
                <Label
                    htmlFor={`group-${poiGroupID}poi-${poi.value}-description`}
                >
                    Alt description
                </Label>
                
                <Input
                    id={`group-${poiGroupID}poi-${poi.value}-description`}
                    type="text"
                    value={currentAltDescription}
                    onChange={(e) => setCurrentAltDescription(e.target.value)}
                    onBlur={() => handleAltDataChange({ Description: currentAltDescription }, poi.value, linkedPOI)}
                    disabled={isDisabled}
                />
            </InputContainer>
                  
        </div>
    )
}